import React from 'react';
import PropTypes from 'prop-types';
import ProductSearchBox from './ProductSearchBox';
import ProductResultTable from './ProductResultTable';
import Loader from '../Loader/Loader';
import DismissSaveButtonsPanel from '../Buttons/DismissSaveButtonsPanel';

const Product = (props) => {
    return(
        <div className="col-xs-12">
            <ProductSearchBox
                onSearchInputKeyPressed={props.onSearchInputKeyPressed}
                onSearchInputTextChanged={props.onSearchInputTextChanged}
                onSearchButtonClicked={props.onSearchButtonClicked}
                searchValue={props.product.searchValue}/>
            {props.product.isLoading===true && <Loader /> }
            {props.product.isLoading===false &&
            <ProductResultTable
                products= {props.product.products}
                selectedIndex={props.product.selectedRow? props.product.selectedRow.id : 0}
                onPageChanged={props.onTablePageChange}
                selectedPage= {props.product.tablePage}
                selectedRowChanged = {props.onSelectedTableRowChange} />}
            <DismissSaveButtonsPanel
                isSaveBtnDisabled={!props.product.isRowSelected}
                onDismissButtonClick={props.onDismissButtonClick}
                onSaveButtonClick={props.onSaveButtonClick} />
        </div>
    );
};

Product.propTypes = {
    onSearchInputKeyPressed: PropTypes.func,
    onSearchInputTextChanged: PropTypes.func,
    onSearchButtonClicked: PropTypes.func,
    onTablePageChange: PropTypes.func,
    onSelectedTableRowChange: PropTypes.func,
    product: PropTypes.shape({
        searchValue: PropTypes.string,
        products: PropTypes.array,
        selectedRow: PropTypes.shape({
            id: PropTypes.number
        }),
        isLoading: PropTypes.bool,
        tablePage: PropTypes.number,
        isRowSelected: PropTypes.bool
    }),
    onDismissButtonClick: PropTypes.func,
    onSaveButtonClick: PropTypes.func
};

export default Product;


// WEBPACK FOOTER //
// ./src/components/Product/Product.js